import { FilterAlbumType, FilterInstrumental, FollowItemType, PageModuleType, RestCampaignData, SetlistCover, SetlistTrackType } from '@/types'
import { sleep } from '@/utils/sleep'

const mockData: RestCampaignData = {
  user_journey: {
    steps: [
      { position: 0, name: 'Home' },
      { position: 1, name: 'Newsletter' },
      { position: 2, name: 'Login' },
      { position: 3, name: 'Playlist' },
      { position: 4, name: 'Result' },
    ]
  },
  playlist_name: 'GA-20 House Party Picks',
  artist_playlist: '',
  artists: [{ spotify_id: '6P7H3ai06vU1sGvdpBwDmE' }],
  playlists: [{ spotify_id: '37i9dQZF1DZ06evO0AysTR' }],
  external_tracks: [],
  filters: {
    first_artist_only: false,
    artist_album_types: [FilterAlbumType.ALBUM, FilterAlbumType.SINGLE],
    instrumental: FilterInstrumental.INCLUDE,
  },
  is_competition: false,
  setlist_normal_tracks_limit: 30,
  community_playlist_track_limit: null,
  setlist_track_types: [SetlistTrackType.NORMAL],
  streaming_services: ['spotify'],
  setlist_cover_image: 'https://www.rnd.de/resizer/4VkFhN2WljJ1ZrEEKSVRH9dL1C8=/369x208/filters:quality(70)/arc-anglerfish-eu-central-1-prod-madsack.s3.amazonaws.com/public/W3QXZIONUNC77LXAVYX7DWZQV4.jpeg',
  community_setlist_cover_image: null,
  frontend: {
    campaignTrackNormalMin: 9,
    page_modules_result: [
      {
        type: PageModuleType.CHART,
        data: {
          en: {
            title: 'English chart title',
            text: 'text',
            buttonShare: 'Share',
            buttonOpen: 'Open',
            buttonRestart: 'Restart',
          },
          de: {
            title: 'German chart title',
            text: 'text',
            buttonShare: 'Share',
            buttonOpen: 'Open',
            buttonRestart: 'Restart',
          }
        }
      },
      {
        type: PageModuleType.PLAYLIST,
        data: {
          en: {
            title: 'Playlist',
            buttonSave: 'Save to your Spotify library',
            buttonShare: 'Share',
            buttonOpen: 'Open',
          },
          de: {
            title: 'Playlist',
            buttonSave: 'Save to your Spotify library',
            buttonShare: 'Share',
            buttonOpen: 'Open',
          }
        }
      },
      {
        type: PageModuleType.ADVERTISEMENT,
        data: {
          en: {
            title: 'Danke, dass du mitgemacht hast!',
            text: 'Du willst deine Playlist noch mal erstellen? Dann lass uns noch mal von vorne anfangen',
            imageUrl: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            buttonLink: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            button: 'See more',
            buttonLinkShopeName: 'Mediamarkt',
            buttonLinkType: 'D2C - Buy',
          },
          de: {
            title: 'Danke, dass du mitgemacht hast!',
            text: 'Du willst deine Playlist noch mal erstellen? Dann lass uns noch mal von vorne anfangen',
            imageUrl: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            buttonLink: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            button: 'See more',
            buttonLinkShopeName: 'Mediamarkt',
            buttonLinkType: 'D2C - Buy',
          }
        }
      },
      {
        type: PageModuleType.VIDEO,
        data: {
          en: {
            title: 'English video title',
            videoUrl: 'https://www.youtube.com/embed/9-ThusbaRW8'
          },
          de: {
            title: 'German video title',
            videoUrl: 'https://www.youtube.com/embed/9-ThusbaRW8'
          }
        }
      },
      {
        type: PageModuleType.SOCIAL,
        data: {
          en: {
            title: 'Social title',
            youtube: 'https://www.youtube.com/channel/UC-lHJZR3Gqxm24_Vd_AJ5Yw',
            instagram: 'https://www.instagram.com/16bars/',
            twitter: 'https://twitter.com/16bars',
            facebook: 'https://www.facebook.com/16bars',
            tiktok: 'https://www.tiktok.com/@16bars',
          },
          de: {
            title: 'Social title',
            youtube: 'https://www.youtube.com/channel/UC-lHJZR3Gqxm24_Vd_AJ5Yw',
            instagram: 'https://www.instagram.com/16bars/',
            twitter: 'https://twitter.com/16bars',
            facebook: 'https://www.facebook.com/16bars',
            tiktok: 'https://www.tiktok.com/@16bars',
          }
        }
      }
    ],
    page_modules_end: [
      {
        type: PageModuleType.CHART,
        data: {
          en: {
            title: 'English chart title',
            text: 'text',
            buttonShare: 'Share',
            buttonOpen: 'Open',
          },
          de: {
            title: 'German chart title',
            text: 'text',
            buttonShare: 'Share',
            buttonOpen: 'Open',
          }
        }
      },
      {
        type: PageModuleType.ADVERTISEMENT,
        data: {
          en: {
            title: 'Danke, dass du mitgemacht hast!',
            text: 'Du willst deine Playlist noch mal erstellen? Dann lass uns noch mal von vorne anfangen',
            imageUrl: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            buttonLink: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            button: 'See more',
            buttonLinkShopeName: 'Mediamarkt',
            buttonLinkType: 'D2C - Buy',
          },
          de: {
            title: 'Danke, dass du mitgemacht hast!',
            text: 'Du willst deine Playlist noch mal erstellen? Dann lass uns noch mal von vorne anfangen',
            imageUrl: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            buttonLink: 'https://www.16bars.de/wp-content/uploads/2020/01/badmomzjay-750x400.jpg',
            button: 'See more',
            buttonLinkShopeName: 'Mediamarkt',
            buttonLinkType: 'D2C - Buy',
          }
        }
      },
      {
        type: PageModuleType.VIDEO,
        data: {
          en: {
            title: 'English video title',
            videoUrl: 'https://www.youtube.com/embed/9-ThusbaRW8'
          },
          de: {
            title: 'German video title',
            videoUrl: 'https://www.youtube.com/embed/9-ThusbaRW8'
          }
        }
      },
      {
        type: PageModuleType.SOCIAL,
        data: {
          en: {
            title: 'English title',
            youtube: 'youtube',
            instagram: 'instagram',
            twitter: 'twitter',
            facebook: 'facebook',
            tiktok: 'https://www.tiktok.com/@16bars',
          },
          de: {
            title: 'German title',
            youtube: 'youtube',
            instagram: 'instagram',
            twitter: 'twitter',
            facebook: 'facebook',
            tiktok: 'https://www.tiktok.com/@16bars',
          }
        }
      },
      {
        type: PageModuleType.NEWSLETTER,
        data: {
          en: {
            title: 'Newsletter',
            terms: 'Please accept the terms',
            button: 'Subscribe',
            success: 'Well done!',
          },
          de: {
            title: 'Newsletter DE',
            terms: 'Please accept the terms',
            button: 'Subscribe',
            success: 'Well done!',
          }
        }
      }
    ],
    page_modules_chart: [
      {
        type: PageModuleType.CHART,
        data: {
          en: {
            title: 'English chart title',
            text: 'text',
            buttonShare: 'Share',
            buttonOpen: 'Open',
          },
          de: {
            title: 'German chart title',
            text: 'text',
            buttonShare: 'Share',
            buttonOpen: 'Open',
          }
        }
      },
    ],
    theme: {
      isDark: true,
      primaryColor: '#0E34AB',
      font: 'Merriweather',
      logoImageUrl: 'https://logos-world.net/wp-content/uploads/2020/11/The-Rolling-Stones-Emblem.png',
      headerImageUrl: 'https://www.groningermuseum.nl/de/media/2/Tentoonstellingen/2020/RS/_1200x630_crop_center-center_82_none/TheRollingStones.jpg?mtime=1594374283',
      backgroundImageUrl: 'https://upload.wikimedia.org/wikipedia/commons/1/10/The_Rolling_Stones_Summerfest_in_Milwaukee_-_2015.jpg',
      newsletterImageUrl: '',
    }
  },
  follow: [
    {
      service: 'spotify',
      id: '01C9OoXDvCKkGcf735Tcfo',
      type: FollowItemType.ARTIST,
    }
  ]
}

class CampaignRestMock {
  public async get (token: string | null, id: number): Promise<RestCampaignData> {
    await sleep(1200)

    let data = { id, ...mockData }

    switch (id) { // id 4 is used to test setlist
      case 2: {
        data = {
          ...mockData,
          id,
          setlist_track_types: [
            SetlistTrackType.OPENING,
            SetlistTrackType.NORMAL,
            SetlistTrackType.CLOSING,
            SetlistTrackType.ENCORE,
          ]
        }
        break
      }
      case 6:
      case 4: { // id 4/6 is used to test competiton
        data = {
          ...mockData,
          id,
          is_competition: true,
        }
        break
      }
      case 5: { // id 5 is used to test ended campaign
        data = {
          ...mockData,
          id,
        }
        break
      }
      default: {
        break
      }
    }

    return new Promise((resolve) => resolve(data))
  }

  public async create (token: string | null, data: RestCampaignData): Promise<RestCampaignData> {
    await sleep(1200)

    return new Promise((resolve) => resolve({
      id: 99999,
      ...mockData,
    }))
  }

  public async update (token: string | null, id: number, data: RestCampaignData): Promise<RestCampaignData> {
    await sleep(1200)

    return new Promise((resolve) => resolve({
      id,
      ...mockData,
    }))
  }

  public async getSetlistCover (id: number): Promise<SetlistCover> {
    await sleep(300)
    // 1x1 transparent pixel; enough for the mock flow without a real Spotify call.
    return new Promise((resolve) => resolve({
      image: '/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////wAALCAABAAEBAREA/8QAFAABAAAAAAAAAAAAAAAAAAAAA//EABQQAQAAAAAAAAAAAAAAAAAAAAD/2gAIAQEAAD8AfwD/2Q==',
    }))
  }
}

export default new CampaignRestMock()
